
async function multiRedisCache (redis, prefix, ttl, ids, fn, options) {
    if (!(prefix.includes('{') && prefix.includes('}'))) {
        throw new Error('multiIdCache requires a prefix with a slot hash');
    }

    const resultMap = {};

    if (ids.length === 0) {
        return resultMap;
    }

    let uniqueIds = Array.from(new Set(ids));
    const keys = new Set();
    for (const uid of uniqueIds) {
        keys.add(prefix + uid);
    }

    const missingIds = [];

    if (options && options.refresh) {
        // Simply treat all ids as missing when refresh is requested
        missingIds.push(...ids);
    } else {
        const cacheResults = await redis.mget(Array.from(keys));

        for (let i = 0; i < uniqueIds.length; ++i) {
            const id = uniqueIds[i];
            const res = cacheResults[i];

            if (options && options.willInsertMissing && (! res || res === 'null' || res === 'undefined')) {
                missingIds.push(id);
            } else if (res === null || res === undefined) {
                missingIds.push(id);
            } else if (res === 'null') {
                resultMap[id] = null;
            } else if (res === 'undefined') {
                // Do nothing - we dont want the key to be set
            } else {
                try {
                    resultMap[id] = JSON.parse(res);
                } catch (e) {
                    console.info('Failed parsing result ' + id + ' from multiIdCache');
                    console.info(res);
                }
            }
        }
    }

    if (missingIds.length > 0) {
        const loadedEntityMap = await fn(missingIds);

        if (options?.noWriteCache) {
            for (const id in loadedEntityMap) {
                const value = loadedEntityMap[id];
                resultMap[id] = value;

                // @TODO handle willInsertMissing?
            }
        } else {
            // Start a Redis pipeline
            const pipeline = redis.pipeline();

            for (const id in loadedEntityMap) {
                const value = loadedEntityMap[id];
                resultMap[id] = value;

                // Add SET command with EXPIRE to the pipeline for each entity
                pipeline.set(prefix + id, JSON.stringify(value), 'EX', ttl);
            }

            for (const id of uniqueIds) {
                if (! (id in resultMap)) {
                    if (options && options.willInsertMissing) {
                        console.error('Error in multiRedisCache, was expected to insert but still missing id ' + id);
                    }
                    // Still missing
                    pipeline.set(prefix + id, 'undefined', 'EX', ttl);
                }
            }

            // Execute all commands in the pipeline in a single go
            pipeline.exec();
        }
    }

    return resultMap;
}

module.exports = multiRedisCache;
